<div class="p-6 max-w-3xl mx-auto">

  <!-- Loading -->
  @if (isLoading()) {
    <div class="flex items-center justify-center py-16">
      <div class="animate-spin rounded-full h-10 w-10 border-b-2 border-blue-600"></div>
    </div>
  }

  <!-- Not found -->
  @if (!isLoading() && !demande()) {
    <div class="bg-red-50 border border-red-200 rounded-lg p-6 text-center">
      <p class="text-red-700">Demande introuvable.</p>
      <button (click)="goBack()" class="mt-4 text-blue-600 hover:underline text-sm">← Retour aux demandes</button>
    </div>
  }

  <!-- Demande detail -->
  @if (!isLoading() && demande(); as d) {
    <!-- Header -->
    <div class="flex items-center justify-between mb-6">
      <button (click)="goBack()" class="text-gray-500 hover:text-gray-800 text-sm flex items-center gap-1">
        ← Retour
      </button>
      <span [class]="'inline-flex items-center px-3 py-1 rounded-full text-sm font-medium ' + getStatusClass(d.demande_status)">
        {{ getStatusLabel(d.demande_status) }}
      </span>
    </div>

    <!-- Main card -->
    <div class="bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden">
      <div class="px-6 py-4 border-b border-gray-100 bg-gray-50">
        <h2 class="text-lg font-semibold text-gray-800">Demande #{{ d.demande_id }}</h2>
        <p class="text-sm text-gray-500 mt-0.5">{{ d.entity_type | titlecase }} — {{ d.demande_type }}</p>
      </div>

      <div class="px-6 py-5 grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <p class="text-xs text-gray-500 uppercase tracking-wide mb-0.5">Nom</p>
          <p class="text-sm font-medium text-gray-800">{{ d.data_last_name }} {{ d.data_first_name }}</p>
        </div>
        @if (d.club_name) {
          <div>
            <p class="text-xs text-gray-500 uppercase tracking-wide mb-0.5">Club</p>
            <p class="text-sm font-medium text-gray-800">{{ d.club_name }}</p>
          </div>
        }
        @if (d.source_club_name) {
          <div>
            <p class="text-xs text-gray-500 uppercase tracking-wide mb-0.5">Club source (transfert)</p>
            <p class="text-sm font-medium text-gray-800">{{ d.source_club_name }}</p>
          </div>
        }
        @if (d.licenceperiod_name) {
          <div>
            <p class="text-xs text-gray-500 uppercase tracking-wide mb-0.5">Période de licence</p>
            <p class="text-sm font-medium text-gray-800">{{ d.licenceperiod_name }}</p>
          </div>
        }
        @if (d.data_identity_number) {
          <div>
            <p class="text-xs text-gray-500 uppercase tracking-wide mb-0.5">N° identité</p>
            <p class="text-sm font-medium text-gray-800">{{ d.data_identity_number }}</p>
          </div>
        }
        @if (d.data_birthday) {
          <div>
            <p class="text-xs text-gray-500 uppercase tracking-wide mb-0.5">Date de naissance</p>
            <p class="text-sm font-medium text-gray-800">{{ d.data_birthday }}</p>
          </div>
        }
        @if (d.submitted_by_name) {
          <div>
            <p class="text-xs text-gray-500 uppercase tracking-wide mb-0.5">Soumis par</p>
            <p class="text-sm font-medium text-gray-800">{{ d.submitted_by_name }}</p>
          </div>
        }
        <div>
          <p class="text-xs text-gray-500 uppercase tracking-wide mb-0.5">Date de création</p>
          <p class="text-sm font-medium text-gray-800">{{ d.created_at | date:'dd/MM/yyyy HH:mm' }}</p>
        </div>
        @if (d.motif) {
          <div class="sm:col-span-2">
            <p class="text-xs text-gray-500 uppercase tracking-wide mb-0.5">Motif</p>
            <p class="text-sm font-medium text-red-700">{{ d.motif }}</p>
          </div>
        }
      </div>
    </div>

    <!-- FED_VALIDATED info -->
    @if (showLicenceGeneratedInfo) {
      <div class="mt-4 bg-green-50 border border-green-200 rounded-lg p-4 text-sm text-green-800">
        Demande validée par la fédération — en attente de génération de licence (backoffice).
      </div>
    }

    <!-- Action panel -->
    @if (pendingAction()) {
      <div class="mt-6 bg-white border border-gray-200 rounded-xl shadow-sm p-5">
        <h3 class="text-sm font-semibold text-gray-700 mb-3">Confirmer l'action</h3>
        @if (showMotifInput()) {
          <textarea
            [(ngModel)]="motif"
            (ngModelChange)="motif.set($event)"
            [value]="motif()"
            rows="3"
            placeholder="Motif (obligatoire)"
            class="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 mb-3"
          ></textarea>
        }
        <div class="flex gap-3">
          <button
            (click)="confirmAction()"
            [disabled]="isActing()"
            class="px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700 disabled:opacity-50"
          >
            {{ isActing() ? 'En cours...' : 'Confirmer' }}
          </button>
          <button
            (click)="cancelAction()"
            class="px-4 py-2 bg-gray-100 text-gray-700 text-sm font-medium rounded-lg hover:bg-gray-200"
          >
            Annuler
          </button>
        </div>
      </div>
    }

    <!-- Action buttons -->
    @if (!pendingAction()) {
      <div class="mt-4 flex flex-wrap gap-3">
        @if (canCancel) {
          <button (click)="startAction('cancel')" class="px-4 py-2 bg-stone-100 text-stone-700 text-sm font-medium rounded-lg hover:bg-stone-200">
            Annuler la demande
          </button>
        }
        @if (canClubAction) {
          <button (click)="startAction('club-accept')" class="px-4 py-2 bg-green-600 text-white text-sm font-medium rounded-lg hover:bg-green-700">
            Accepter le transfert
          </button>
          <button (click)="startAction('club-reject')" class="px-4 py-2 bg-red-600 text-white text-sm font-medium rounded-lg hover:bg-red-700">
            Refuser le transfert
          </button>
        }
        @if (canFedAction) {
          <button (click)="startAction('validate')" class="px-4 py-2 bg-green-600 text-white text-sm font-medium rounded-lg hover:bg-green-700">
            Valider
          </button>
          <button (click)="startAction('reject')" class="px-4 py-2 bg-red-600 text-white text-sm font-medium rounded-lg hover:bg-red-700">
            Rejeter
          </button>
        }
      </div>
    }
  }

</div>
